//Import all stylesheets
import Borrows from "./../styles/Borrows";
import Home from "./../styles/Home";
import Login from "./../styles/Login";
import Logout from "./../styles/Logout";
import Materials from "./../styles/Materials";
import Navigation from "./../styles/Navigation";
import QrCodeReader from "./../styles/QrCodeReader";

/**
 * @description Style Manager that contain all stylesheets
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class StyleManager
 */
export class StyleManager {
    /**
     * @description Get the StyleManager
     * @author Lucas Fridez <lfridez@artionet.com>
     * @readonly
     * @static
     * @memberof StyleManager
     */
    public static getStyles() {
        return StyleManager.styles;
    }

    private static styles = {
        BorrowsView: Borrows,
        HomeView: Home,
        LoginView: Login,
        LogoutView: Logout,
        MaterialsView: Materials,
        NavigationComponent: Navigation,
        QrCodeReaderComponent: QrCodeReader
    };
}



// WEBPACK FOOTER //
// ./src/app/managers/StyleManager.ts